import React from 'react';
import { CurrentUserFieldsFragment } from 'src/gqlReactTypings.generated.d';
import { BecomeAShef } from 'src/shared/design-system/Icon';
import { Routes } from 'src/shared/Routes';
import { match } from 'ts-pattern';
import { getShefLinkType } from '../../header-v2/utils';
import { MenuItem } from './MenuItem';

interface IProps {
  currentUser: CurrentUserFieldsFragment | null;
  onClick: () => void;
}

export const ShefMenuItem: React.FC<IProps> = ({ currentUser, onClick }) => {
  const shefLinkType = getShefLinkType(currentUser);
  const icon = <BecomeAShef height='24px' width='24px' outline />;

  return match({ shefLinkType })
    .with({ shefLinkType: 'shef-dashboard' }, () => (
      <MenuItem
        name='shef-dashboard'
        icon={icon}
        onClick={onClick}
        text='Shef dashboard'
        href={Routes.SHEF}
        type='link'
      />
    ))
    .with({ shefLinkType: 'shef-application' }, () => (
      <MenuItem
        name='application-status'
        icon={icon}
        onClick={onClick}
        text='Application status'
        href={Routes.SHEF_APPLICATION}
        type='link'
      />
    ))
    .with({ shefLinkType: 'waitlist-home' }, () => (
      <MenuItem
        name='waitlist-status'
        icon={icon}
        onClick={onClick}
        text='Waitlist status'
        href={Routes.WAITLIST_HOME}
        type='link'
      />
    ))
    .with({ shefLinkType: 'become-a-shef' }, () => null)
    .exhaustive();
};
